/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Verify_Please_WaitInputs */



/**
* | output |
* | --- |
* | "Please wait" |
*
* @param {Auth_Verify_Please_WaitInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const auth_verify_please_wait = /** @type {((inputs?: Auth_Verify_Please_WaitInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Verify_Please_WaitInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Veuillez patienter")
	if (locale === "es") return /** @type {LocalizedString} */ ("Por favor, espere")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Por favor, aguarde")
	if (locale === "it") return /** @type {LocalizedString} */ ("Attendere prego")
	return /** @type {LocalizedString} */ ("Please wait")
});